import React from 'react';
import './MissCiScratch.css';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/NewHeader/Header';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getWallet } from '../../store/actions';

export default function MissCiScratch() {
  const isAuthenticated = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  console.log(
    'process.env.REACT_APP_MISS_CI_2026',
    process.env.REACT_APP_MISS_CI_2026,
  );

  window.onmessage = function (e) {
    if (e.data === 'called') {
      dispatch(getWallet());
    }
  };

  return (
    <>
      <Header />
      {isAuthenticated ? (
        <div className='missCI-iframe'>
          <iframe
            title=' '
            src={`${process.env.REACT_APP_MISS_CI_2026}?token=${localStorage.getItem('token')}`}
            width='100%'
            height='100%'
            allow='autoplay'
          ></iframe>
        </div>
      ) : (
        <div className='game-subcontainer game-loggedout'>
          <div className='sratch-logout'>
            <h4 className='bigTtile'>Miss CI 2026</h4>
            <Link className='login-game' to='/login'>
              CONNECTEZ-VOUS ET JOUEZ
            </Link>
          </div>
          <div className='extra-scratch ae absolute'></div>
        </div>
      )}
      <Footer />
    </>
  );
}
